export default "__VITE_PUBLIC_ASSET__f8cb6651__"